import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import printDiv from "../../../../helpers/print_data";
import showNotification from "../../../../helpers/show_notification";
import { ExportAvailableInCSVForReports, formatUnitsForReport } from "../../../../helpers/units";

const CentralStoreWastedInventory = (props) => {
  const { SearchBar } = Search;
  useEffect(() => {
    loadItems();
  }, []);

  const [allItems, setAllItems] = useState([]);
  const loadItems = async () => {
    let url = process.env.REACT_APP_BASEURL + "branchiteminventories/wasted";
    const response = await postSubmitForm(url, {});
    if (response && response.status === 1) {
      setAllItems(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };



  const columns = [
    {
      dataField: "_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      csvExport: false,
    },
    {
      text: props.t("Name"),
      dataField: "item_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "16%" };
      },
    },
    {
      dataField: "item_details.category",
      text: props.t("Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "item_details.sub_category",
      text: props.t("Sub-Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },

    {
      dataField: "quantity",
      text: props.t("Quantity"),
      formatter: (cell, row) =>{
        return formatUnitsForReport(row.quantity)
      },
      csvFormatter: (cell, row) => { 
        return formatUnitsForReport(row.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "createdAt",
      text: props.t("Wasted On"),
      formatter: (cell, row) => moment(row.createdAt).format("DD-MM-YYYY HH:mm"),
      csvFormatter: (cell, row) => moment(row.createdAt).format("DD-MM-YYYY HH:mm"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
     {
      text: props.t("Remarks"),
      dataField: "remarks",
      formatter: (cell, row) => (
        <div
          style={{
            fontSize: "11px",
            lineHeight: "2",
            color: "#5d6d7e",
          }}
        >
          {row.remarks && (
            <div>
              <div>{row.remarks}</div>
            </div>
          ) 
          }
        </div>
      ),
      editable: false,
       headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
  ];
  const handleDownload = async () => {
    const fileName = "wasted_item_inventory_report";
    const exportType = "xls";

    let data_to_export = allItems;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          Name: v.item_details.name,
          Category: v.item_details.category,
          Sub_Category: v.item_details.sub_category,
          Quantity: ExportAvailableInCSVForReports(v.quantity),
          Wasted_On: moment(v.createdAt).format("DD-MM-YYYY HH:mm "),
          Remarks: v.remarks,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Item")}
            title={props.t("Inventory")}
            breadcrumbItem1={props.t("Items")}
            breadcrumbItem2={props.t("Wasted Item Inventory")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  
                  <div id="printDiv">
                    <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary mr-2 d-print-none"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success d-print-none"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                    <Col lg={4} sm={4} md={4}>
                    <CardTitle className="text-center">
                      {props.t("Wasted Item Inventory")}
                    </CardTitle>
                    </Col>
                  </Row>
                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allItems && allItems}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                      exportCSV
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4} className="text-right"></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(CentralStoreWastedInventory))
);
